// extracted by mini-css-extract-plugin
export default {"heroWrapper":"style-module--heroWrapper--59d70"};